export const APP_NAME = 'QDN';
export const APP_FULL_NAME = 'Queer Data Network';

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  PROFILE: '/profile',
  PROFILE_EDIT: '/profile/edit',
  CHANGE_PASSWORD: '/profile/change-password',
  USER: (id) => `/users/${id}`,
  CONTENT: '/content',
  COMMUNITY: '/community',
  ABOUT: '/about',
  CODE_OF_CONDUCT: '/code-of-conduct',
  TERMS_OF_SERVICE: '/terms-of-service',
  GETTING_STARTED: '/getting-started',
  PRIVACY_POLICY: '/privacy-policy',
  CONTACT: '/contact',
  SUPPORT: '/support',
  ADMIN: '/admin',
};

export const API_ENDPOINTS = {
  AUTH: {
    REGISTER: '/auth/register',
    LOGIN: '/auth/login',
    ME: '/auth/me',
    REFRESH: '/auth/refresh',
  },
  USERS: {
    GET: (id) => `/users/${id}`,
    UPDATE: '/users/update',
    ME: '/users/me',
  },
  CONTENT: {
    LIST: '/content',
    GET: (id) => `/content/${id}`,
    CREATE: '/content',
    UPDATE: (id) => `/content/${id}`,
    DELETE: (id) => `/content/${id}`,
    HIDE: (id) => `/content/${id}/hide`,
    REPORT: (id) => `/content/${id}/report`,
  },
  ACTIVITY: {
    LIST: '/activity',
    GET: (id) => `/activity/${id}`,
    CREATE: '/activity',
    UPDATE: (id) => `/activity/${id}`,
    DELETE: (id) => `/activity/${id}`,
    HIDE: (id) => `/activity/${id}/hide`,
    REPORT: (id) => `/activity/${id}/report`,
  },
  ADMIN: {
    REPORTS: '/moderation/reports',
    USERS: '/management/users',
    UPDATE_USER_ROLE: (id) => `/management/users/${id}/role`,
  },
};

export const USER_ROLES = {
  MEMBER: 'member',
  MODERATOR: 'moderator',
  ADMIN: 'admin',
};

export const CONTENT_TYPES = {
  POST: 'post',
  PAGE: 'page',
};

export const ACTIVITY_TYPES = {
  POST: 'post',
  EVENT: 'event',
  ANNOUNCEMENT: 'announcement',
};

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'qdn_access_token',
  REFRESH_TOKEN: 'qdn_refresh_token',
  USER_PREFERENCES: 'qdn_user_preferences',
};

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,
};

export const VALIDATION_RULES = {
  EMAIL: {
    MAX_LENGTH: 254,
    PATTERN: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  },
  PASSWORD: {
    MIN_LENGTH: 8,
    MAX_LENGTH: 128,
  },
  DISPLAY_NAME: {
    MIN_LENGTH: 2,
    MAX_LENGTH: 50,
    PATTERN: /^[a-zA-Z0-9\s._-]+$/,
  },
  BIO: {
    MAX_LENGTH: 500,
  },
  LINKS: {
    MAX_COUNT: 10,
    MAX_LENGTH: 500,
    PATTERN: /^https?:\/\/[^\s/$.?#].[^\s]*$/,
  },
};